<template>
    <div class="finish">
        <a @click="goFinish()" class="button" id="btnFinish">Finish</a>
        <div v-if="active == true" class="popup">
            <div class="popup-content">
                <div class="close"
                     @click="
            active = false;
          "></div>
                <p class="">
                    Purchase your {{ this.productInfo.productName.toLowerCase() }} as a fully stitched finished product or as a needlepoint kit and create it yourself. Choose your
                    option below.
                </p>
                <div class="section">


                    <div class="columns">

                        <div class="generate">
                            <h2>
                                Hand stitched &amp; Finished Needlepoint
                                {{ this.productInfo.productName }}
                            </h2>
                            <div class="price">
                                ${{
                    (
                      Math.round(
                        this.productInfo.sizes.find(
                          (s) => s.sizeId == this.userProduct.sizeId
                        ).sizePrice * 100
                      ) / 100
                    ).toFixed(2)
                                }}
                            </div>
                            <button id="btnSubmitProduct" v-on:click="submitProduct(false)">
                                Generate {{ this.productInfo.productName }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="section">



                    <div class="columns">

                        <div class="generate">
                            <h2>Custom Needlepoint {{ this.productInfo.productName }} Kit</h2>
                            <div class="price">
                                <span>From</span>
                                ${{
                    (
                      Math.round(
                        this.productInfo.sizes.find(
                          (s) => s.sizeId == this.userProduct.sizeId
                        ).sizeCanvasPrice * 100
                      ) / 100
                    ).toFixed(2)
                                }}
                            </div>
                            <button id="btnSubmitCanvas" v-on:click="submitProduct(true)">
                                Generate Canvas
                            </button>


                        </div>
                    </div>
                </div>
                <div class=" section">
                    <div class="columns">

                        <div class="generate">
                            <button id="btnSubmitCanvas" class="button secondary" v-on:click="active=false">
                                Keep Designing
                            </button>
                        </div>
                        </div>
                    </div>
                    </div>

                    <div class="overlay" @click="closeFinish()"></div>
                </div>
    </div>
</template>

<script>

    import Globals from "@/globals.js";
    import ProductService from "@/services/ProductService.js";
    
    import { mapState } from "vuex";

    export default {
        name: "Finish",
        props: [],
        computed: {
            ...mapState(["productInfo", "userProduct"]),
        },

        data() {
            return {
                //cmInputs: null,
                //error: null,
                //createdMotif: this.motif,
                //edit: false,
                //currentImageSrc: this.motif.motifImageData,
                //timeout: null,
                //debounce: null,
                //isTyping: false,
                active: false,
                productType: Globals.getProductType(),
                //maxWidth1: (Globals.getProductType()==7 ? 4 : 20)
            };
        },
        methods: {
            submitProduct(canvasOnly) {
                this.active = false;
                this.$store.dispatch("finishProduct", canvasOnly);

            },
            goFinish() {
                console.log("Finish Step: ", Globals.getFinishStep());
                if (Globals.showFinishToggle()) {
                    this.$store.dispatch("finishProduct", this.userProduct.finishStep == 1);
                } else if ((Globals.getFinishStep() == 0)) {
                    this.active = true;
                } else {
                    this.$store.dispatch("finishProduct", null)
                }
                
                
            },
            closeFinish() {
                this.active = false;
            },
        },
        components: {
            //ProductSelections,
        },
        created() { },
        updated() { },
        mounted() { },
    };
</script>

<style>

    .finish {
        text-align: left;
    }


    #npHeader .finish h2 {
        line-height: 1em;
        float:left;
    }

        .finish .section {
            margin-top: 2em;
            padding-top: 1em;
            border-top: dashed 1px #666;
        }

    [data-route="Finish"] #npHeader .product-selections {
        display: none;
    }

    .columns {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin: auto;
    }

    .review {
    }

    .columns .generate {
        /*! flex: 1 0 auto; */
        text-align: right;
    }

    .columns > div {
        /*! min-width: 200px; */
        width: 100%;
        /*! max-width: 325px; */
        margin-bottom: 1em;
        padding: 0 1em;
    }

    .review h3 {
        margin-top: 0;
    }

    .generate {
    }

        .generate button {
            width: 100%;
            margin-top:.5em;
        }

        .generate .price {
            color: #666;
        }

        .generate button {
            min-width: 12em;
            width: 100%;
        }

    

        
</style>
